const initialState = {
  cartProductDetails: []
};

const OrchestrationReducer = (state = initialState, action) => {
  if (action.type === 'GET_CART_PRODUCT_DETAILS') {
    return {
      ...state,
      cartProductDetails: action.payload
    };
  }
  return state;
};

export default OrchestrationReducer;
